"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _nicbaseTranslation = require("nicbase-translation");

var _dataRequestFormModule = _interopRequireDefault(require("./data-request-form.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DataRequestError = function DataRequestError() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _dataRequestFormModule["default"].assetAssignment
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _dataRequestFormModule["default"].header
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.header",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _dataRequestFormModule["default"].content
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.error",
    tagName: "span"
  })));
};

var _default = DataRequestError;
exports["default"] = _default;